/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-disable no-underscore-dangle */

import { v4 as uuidv4 } from 'uuid';

/**
 * @import { FingerprintManager } from '.'
 * @import FingerprintHasher from './fingerprint-hasher'
 */

/**
 * Generátor otisku na základě vygenerovaného UUID.
 * @implements {FingerprintManager}
 */
export default class FingerprintUuid {
  /**
   * Vytvoří instanci.
   * @param {FingerprintHasher} hasher Objekt pro hashování informací.
   */
  constructor(hasher) {
    this.hasher = hasher;

    /** @type {string | undefined} */
    this._uuid = undefined;
  }

  /** @type {FingerprintManager['generate']} */
  async generate() {
    return this.hasher.hashObject({ uuid: await this.uuid() });
  }

  /**
   * @private
   * @returns {string}
   */
  uuid() {
    if (!this._uuid) {
      this._uuid = uuidv4();
    }
    return this._uuid;
  }
}
